import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  adoptersInfo: [],
};

export const adoptersInfoSlice = createSlice({
  name: "useCaseAdoptersInfo",
  initialState,
  reducers: {
    adoptersStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    adoptersSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      adoptersInfo: [
        ...state.adoptersInfo,
        action.payload,
      ],
    }),
    adoptersFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    })
  },
});

export const { 
  adoptersStart, adoptersSuccess, adoptersFailure,
} = adoptersInfoSlice.actions;

export const getAdoptersDetailsInfo = ({ useCaseId, adopterId}) => (dispatch) => {
  dispatch(adoptersStart());
  const apiPath =  `${Constants.API.USE_CASE_DETAIL}/${useCaseId}${Constants.API.USE_CASE_CASE_STUDY}${adopterId}`;
  apiService.get(apiPath).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0 && data?.data?.id) {
        dispatch(adoptersSuccess(data?.data));
      } else {
        dispatch(adoptersFailure());
      }
    } else {
      dispatch(adoptersFailure());
    }
  }).catch(() => {
    dispatch(adoptersFailure());
  })
};

export default adoptersInfoSlice.reducer;
